import { navbarOption, SidebarOptions } from "../types";

export const AllSidebarOptions: SidebarOptions[] = [
  {
    id: "dataValidation",
    label: "Checkmate",
    icon: "uiConfigIcon",
    route: "/dashboard/dataValidation",
    navbarParentLabel: "Checkmate"
  },
  {
    id: "reports2",
    label: "Reports",
    icon: "reportsIcon",
    route: "/dashboard/reports2",
    navbarParentLabel: "Analytics Dashboard",
    newLabel: "Reports-Analytics"
  },
  {
    id: "edaQuantityCompliance2",
    label: "EDA Quantity Compliance",
    icon: "edaComplianceIcon",
    route: "/dashboard/edaQuantityCompliance2",
    navbarParentLabel: "Analytics Dashboard",
    newLabel:"EDA Quantity Compliance-Analytics"
  },
  {
    id: "skuSelectionCompliance2",
    label: "EDA SKU Selection Compliance",
    icon: "edaSkuIcon",
    route: "/dashboard/skuSelectionCompliance2",
    navbarParentLabel: "Analytics Dashboard",
    newLabel: "EDA SKU Selection Compliance-Analytics"
  },
  {
    id: "complianceDashboard2",
    label: "Order Compliance",
    icon: "clipboardIcon",
    route: "/dashboard/complianceDashboard2",
    navbarParentLabel: "Analytics Dashboard",
    newLabel: "Order Compliance-Analytics"
  },
  {
    id: "mdm2",
    label: "MDM",
    icon: "mdmIcon",
    route: "/dashboard/mdm2",
    navbarParentLabel: "MDM and Integration",
    newLabel: "MDM-Integration"
  },
  {
    id: "integrationPlatform2",
    label: "Integration Platform",
    icon: "integrationIcon",
    route: "/dashboard/integrationPlatform2",
    navbarParentLabel: "MDM and Integration",
    newLabel: "Integration Platform-Integration"
  },
  {
    id: "checkalter",
    label: "ControlHub",
    icon: "uiConfigIcon",
    route: "/dashboard/checkalter",
    navbarParentLabel: "Checkmate"
  },
  {
    id: "uiConfig",
    label: "UI Config",
    icon: "uiConfigIcon",
    route: "/dashboard/uiConfig",
    navbarParentLabel: "Salescode Studio"
  },
  {
    id: "ClaimsAmt",
    label: "Claims Eligibilty Criteria",
    icon: "uiConfigIcon",
    route: "/dashboard/ClaimsAmt",
    navbarParentLabel: "Salescode Studio"
  }, 
  {
    id: "interfaceSyncMonitor",
    label: "Interface Sync Monitor",
    icon: "uiConfigIcon",
    route: "/dashboard/interfaceSync",
    navbarParentLabel: "Interface Sync Monitor"
  },
  {
    id: "claimsFrequency",
    label: "Claims Generation Frequency",
    icon: "uiConfigIcon",
    route: "/dashboard/claimsFrequency",
    navbarParentLabel: "Salescode Studio"
  },
  {
    id: "uiConfigNew",
    label: "Config Setup",
    icon: "uiConfigIcon",
    route: "/dashboard/newConfig",
    navbarParentLabel: "Salescode Studio"
  },
  {
    id: "mdm",
    label: "MDM",
    icon: "mdmIcon",
    route: "/dashboard/mdm",
    navbarParentLabel: "MDM and Reports"
  },
  {
    id: "mdmNew",
    label: "MDM Upload",
    icon: "mdmIcon",
    route: "/dashboard/newMdm",
    navbarParentLabel: "MDM and Reports"
  },
  {
    id: "reports",
    label: "Reports",
    icon: "reportsIcon",
    route: "/dashboard/reports",
    navbarParentLabel: "MDM and Reports"
  },
  {
    id: "manageTemplateReports",
    label: "Manage Reports Template Based",
    icon: "reportsIcon",
    route: "/dashboard/manageTemplateReports",
    navbarParentLabel: "MDM and Reports"
  },
  {
    id: "createTemplate",
    label: "Create Template",
    icon: "reportsIcon",
    route: "/dashboard/createtemplate",
    navbarParentLabel: "MDM and Reports"
  },
  {
    id: "integrationPlatform",
    label: "Integration Platform",
    icon: "integrationIcon",
    route: "/dashboard/integrationPlatform",
    navbarParentLabel: "MDM and Reports"
  },
  {
    id: "integrationStatistics",
    label: "Integration Statistics",
    icon: "businessImpactIcon",
    route: "/dashboard/integrationStatistics",
    navbarParentLabel: "Performance Analytics"
  },
  {
    id: "registeredFunctions",
    label: "Registered Functions",
    icon: "businessImpactIcon",
    route: "/dashboard/registeredFunctions",
    navbarParentLabel: "MDM and Reports"
  },
  {
    id: "integrationJob",
    label: "Integration Job",
    icon: "businessImpactIcon",
    route: "/dashboard/integrationJob",
    navbarParentLabel: "MDM and Reports"
  },
  {
    id: "splitKeyPage",
    label: "Split Key Page",
    icon: "businessImpactIcon",
    route: "/dashboard/splitKeyPage",
    navbarParentLabel: "MDM and Reports"
  },
  {
    id: "jenkinsJobDetails",
    label: "Jenkins Job Details",
    icon: "businessImpactIcon",
    route: "/dashboard/jenkinsJobDetails",
    navbarParentLabel: "MDM and Reports"
  },
  {
    id: "recipientList",
    label: "Recipient List",
    icon: "businessImpactIcon",
    route: "/dashboard/recipientList",
    navbarParentLabel: "MDM and Reports"
  },
  {
    id: "configComparatorTable",
    label: "Config Comparator",
    icon: "businessImpactIcon",
    route: "/dashboard/configComparatorTable",
    navbarParentLabel: "MDM and Reports"
  },
  {
    id: "oneClickIntegration",
    label: "One Click Integration",
    icon: "checkupIcon",
    route: "/dashboard/oneClickIntegration",
    navbarParentLabel: "MDM and Reports"
  },
  {
    id: "edaQuantityCompliance",
    label: "EDA Quantity Compliance ",
    icon: "edaComplianceIcon",
    route: "/dashboard/edaQuantityCompliance",
    navbarParentLabel: "Impact Prediction"
  },
  {
    id: "skuSelectionCompliance",
    label: "EDA SKU Selection Compliance",
    icon: "edaSkuIcon",
    route: "/dashboard/skuSelectionCompliance",
    navbarParentLabel: "Impact Prediction"
  },
  {
    id: "Analytics",
    label: "Analytics",
    icon: "monitorIcon",
    route: "/dashboard/analytics",
    navbarParentLabel: "Analytics Dashboard"
  },
  {
    id: "sfaAnalytics",
    label: "SFA Analytics",
    icon: "monitorIcon",
    route: "/dashboard/sfaAnalytics",
    navbarParentLabel: "Analytics Dashboard"
  },
  
  {
    id: "historicalDataTabs",
    label: "Historical Data Information",
    icon: "monitorIcon",
    route: "/dashboard/historicalDataTabs",
    navbarParentLabel: "Analytics Dashboard"
  },
  
  // {
  //   id: "orderAnalytics",
  //   label: "Order Analytics",
  //   icon: "orderAnalyticsIcon",
  //   route: "/dashboard/orderAnalytics",
  //   navbarParentLabel: "Live Dashboard"
  // },
  // {
  //   id: "googleAnalytics",
  //   label: "Google Analytics",
  //   icon: "barGraphIcon",
  //   route: "/dashboard/googleAnalytics",
  //   externalFeature: true,
  //   navbarParentLabel: "Analytics Dashboard"
  // },
  // {
  //   id: "performanceDashboard",
  //   label: "Firebase",
  //   icon: "firebaseIcon",
  //   route: "/dashboard/performanceDashboard",
  //   navbarParentLabel: "Analytics Dashboard",
  //   externalFeature: true
  // },
  {
    id: "complianceDashboard",
    label: "Order Compliance",
    icon: "clipboardIcon",
    route: "/dashboard/complianceDashboard",
    navbarParentLabel: "Impact Prediction"
  },
  // {
  //   id: "businessImpact",
  //   label: "Business Impact",
  //   icon: "businessImpactDashboardIcon",
  //   route: "/dashboard/businessImpact",
  //   navbarParentLabel: "Impact Dashboard"
  // },
  {
    id: "manageReport",
    label: "Manage Report",
    icon: "businessImpactIcon",
    route: "/dashboard/manageReport",
    navbarParentLabel: "MDM and Reports"
  },
  {
    id: "appTour",
    label: "Application Tour",
    icon: "businessImpactIcon",
    route: "/dashboard/appTour",
    navbarParentLabel: "App Tour"
  },
  {
    id:"analyticsDashboard",
    label: "Performance Dashboard",
    icon: "businessImpactIcon",
    route: "/dashboard/analyticDashboard",
    navbarParentLabel: "Performance Analytics"
  },
  {
    id:"masterDataReports",
    label: "Master Data Reports",
    icon: "businessImpactIcon",
    route: "/dashboard/masterDataReports",
    navbarParentLabel: "Performance Analytics"
  },
  {
    id: "preGeneratedReports",
    label: "Pre-Generated Reports",
    icon: "businessImpactIcon",
    route: "/dashboard/preGeneratedReports",
    navbarParentLabel: "Performance Analytics"
  },
  {
    id:"validations",
    label: "Validations",
    icon: "businessImpactIcon",
    route: "/dashboard/validations/division",
    navbarParentLabel: "Performance Analytics"
  },
  {
    id:"manageHomeScreen",
    label: "Manage Blocks",
    icon: "businessImpactIcon",
    route: "/dashboard/manageHomeScreen",
    navbarParentLabel: "Salescode Studio"
  },
  {
    id:"newManageHomeScreen",
    label: "Manage Blocks2",
    icon: "businessImpactIcon",
    route: "/dashboard/newManageHomeScreen",
    navbarParentLabel: "Salescode Studio"
  },
  {
    id:"homeScreenManagement",
    label: "HomeScreen Management",
    icon: "businessImpactIcon",
    route: "/dashboard/homeScreenManagement",
    navbarParentLabel: "Salescode Studio"
  },
  // {
  //   id:"eventConfig",
  //   label: "Event Config",
  //   icon: "eventConfigIcon",
  //   route: "/dashboard/eventConfig",
  //   navbarParentLabel: "Salescode Studio"
  // },
  {
    id:"accountStatus",
    label: "Account Status",
    icon: "eventConfigIcon",
    route: "/dashboard/accountStatus",
    navbarParentLabel: "Salescode Studio"
  },
  {
    id:"createAccount",
    label: "Create Account",
    icon: "eventConfigIcon",
    route: "/dashboard/createAccount",
    navbarParentLabel: "Banking"
  },
  {
    id:"retailerPayment",
    label: "Retailer Payment",
    icon: "eventConfigIcon",
    route: "/dashboard/retailerPayment",
    navbarParentLabel: "Banking"
  },
  {
    id:"retailerFinance",
    label: "Retailer Finance",
    icon: "eventConfigIcon",
    route: "/dashboard/retailerFinance",
    navbarParentLabel: "Banking"
  },
  {
    id:"retailerFinanceAdmin",
    label: "Retailer Finance Admin",
    icon: "eventConfigIcon",
    route: "/dashboard/retailerFinanceAdmin",
    navbarParentLabel: "Banking"
  },
  {
    id:"retailerOnboarding",
    label: "Retailer Onboarding",
    icon: "eventConfigIcon",
    route: "/dashboard/retailerOnboarding",
    navbarParentLabel: "Banking"
  },
  {
    id:"adminValidationPage",
    label: "WD Bank Account Approval",
    icon: "eventConfigIcon",
    route: "/dashboard/adminValidationPage",
    navbarParentLabel: "Banking"
  },
  {
    id:"manageOrder",
    label: "Manage Orders",
    icon: "manageOrder",
    route: "/dashboard/sale/manageOrders",
    navbarParentLabel: "Secondary",
  },
  {
    id: "managePrimaryOrder",
    label: "Manage Orders",
    icon: "manageOrder",
    route: "/dashboard/primaryOms/manageOrders",
    navbarParentLabel: "Primary OMS",
  },
  {
    id: "manageInvoice",
    label: "Manage Invoices",
    icon: "manageInvoices",
    route: "/dashboard/sale/manageInvoices",
    navbarParentLabel: "Secondary",
  },
  {
    id: "bulkInvoice",
    label: "Bulk Invoice",
    icon: "bulkInvoice",
    route: "/dashboard/sale/bulkInvoice",
    navbarParentLabel: "Secondary",
  },
  {
    id: "bulkConfirm",
    label: "Bulk Confirm",
    icon: "bulkInvoice",
    route: "/dashboard/sale/bulkConfirm",
    navbarParentLabel: "Secondary",
  },
  {
    id: "createSecondaryOrder",
    label: "Manual Billing",
    icon: "createSecondaryOrder",
    route: "/dashboard/sale/createSecondaryOrder",
    navbarParentLabel: "Secondary",
  },
  {
    id: "manageOutletApproval",
    label: "New Outlet Approval Status",
    icon: "manageOutletApproval",
    route: "/dashboard/sale/manageOutletApproval",
    navbarParentLabel: "Secondary",
  },
  {
    id: "manageOutletApproval2",
    label: "New Outlet Approval Status",
    icon: "manageOutletApproval",
    route: "/dashboard/manageOutletApproval",
    navbarParentLabel: "Outlet Approval",
  },
  {
    id: "manageStockAllocation",
    label: "Manage Stock Allocation",
    icon: "manageStockAllocation",
    route: "/dashboard/sale/manageStockAllocation",
    navbarParentLabel: "Secondary",
  },
  {
    id: "createPrimaryOrder",
    label: "Place New Order",
    icon: "createPrimaryOrder",
    route: "/dashboard/purchase/createPrimaryOrder",
    navbarParentLabel: "Primary",
  },
  {
    id: "viewPrimaryOrders",
    label: "View Primary Orders",
    icon: "viewPrimaryOrders",
    route: "/dashboard/purchase/viewPrimaryOrders",
    navbarParentLabel: "Primary",
  },
  {
    id: "grn",
    label: "View All GRNs",
    icon: "viewAllGRN",
    route: "/dashboard/purchase/grn",
    navbarParentLabel: "Primary",
  },
  {
    id: "realTimeStocks",
    label: "Real Time Stocks",
    icon: "realTimeStock",
    route: "/dashboard/stocks/realTimeStocks",
    navbarParentLabel: "Stocks",
  },
  {
    id: "batchAndExpiryManagement",
    label: "Batch & Expiry Management",
    icon: "batchManagement",
    route: "/dashboard/stocks/batchAndExpiryManagement",
    navbarParentLabel: "Stocks",
  },
  {
    id: "distributorStockTypeUpdate",
    label: "Stock Type Update",
    icon: "stockTypeUpdate",
    route: "/dashboard/stocks/distributorStockTypeUpdate",
    navbarParentLabel: "Stocks",
  },
  {
    id: "companyStockTypeUpdate",
    label: "Stock Type Update",
    icon: "stockTypeUpdate",
    route: "/dashboard/stocks/companyStockTypeUpdate",
    navbarParentLabel: "Stocks",
  },
  {
    id: "manualStockUpdate",
    label: "Manual Stock Adjustment",
    icon: "manualStockUpdate",
    route: "/dashboard/stocks/manualStockUpdate",
    navbarParentLabel: "Stocks",
  },
  {
    id: "companyManualStockUpdate",
    label: "Manual Stock Adjustment",
    icon: "manualStockUpdate",
    route: "/dashboard/stocks/companyManualStockUpdate",
    navbarParentLabel: "Stocks",
  },
  {
    id: "auditTrails",
    label: "Audit Trails",
    icon: "auditTrails",
    route: "/dashboard/stocks/auditTrails",
    navbarParentLabel: "Stocks",
  },
  {
    id: "deliverySettlement",
    label: "Loadouts",
    icon: "loadoutIcon",
    route: "/dashboard/delivery/loadouts",
    navbarParentLabel: "Delivery",
  },
  {
    id: "saleReturns",
    label: "Sale Returns",
    icon: "batchManagement",
    route: "/dashboard/saleReturns",
    navbarParentLabel: "Secondary",
  },
  {
    id: "credit",
    label: "Credit",
    icon: "monitorIcon",
    route: "/dashboard/credit",
    navbarParentLabel: "Credit",
  },
  {
    id: "viewClaimsStatus",
    label: "View Claim Status",
    icon: "viewClaimStatusIcon",
    route: "/dashboard/claims/status",
    navbarParentLabel: "Claims",
  },
  {
    id: "createNewClaim",
    label: "Create New Claim",
    icon: "createNewClaimIcon",
    route: "/dashboard/claims/create",
    navbarParentLabel: "Claims",
  },
  {
    id: "openClaims",
    label: "Open Claims",
    icon: "viewClaimStatusIcon",
    route: "/dashboard/claimsStatus/open",
    navbarParentLabel: "Claims",
  },
  {
    id: "closedClaims",
    label: "Closed Claims",
    icon: "closedClaimIcon",
    route: "/dashboard/claimsStatus/closed",
    navbarParentLabel: "Claims",
  },
  {
    id:"manageBannerStudio",
    label: "Banner",
    icon: "manageBannerStudioIcon",
    route: "/dashboard/manageBannerStudio",
    navbarParentLabel: "Salescode Studio"
  },
  {
    id:"newManageBannerStudio",
    label: "Manage Banner2",
    icon: "manageBannerStudioIcon",
    route: "/dashboard/newManageBannerStudio",
    navbarParentLabel: "Salescode Studio"
  },
  {
    id:"manageBucketStudio",
    label: "Bucket",
    icon: "manageBucketStudioIcon",
    route: "/dashboard/manageBucketStudio",
    navbarParentLabel: "Salescode Studio"
  },
  {
    id:"manageBasketStudio",
    label: "Basket",
    icon: "manageBasketStudioIcon",
    route: "/dashboard/manageBasketStudio",
    navbarParentLabel: "Salescode Studio"
  },
  {
    id:"secondarySaleslens",
    label: "Secondary Saleslens",
    icon: "manageBasketStudioIcon",
    route: "/dashboard/secondarySaleslens",
    navbarParentLabel: "Analytics Dashboard",
    // externalFeature: true
  },
  {
    id:"primarySaleslens",
    label: "Primary Saleslens",
    icon: "manageBasketStudioIcon",
    route: "/dashboard/primarySaleslens",
    navbarParentLabel: "Analytics Dashboard",
    // externalFeature: true
  },
   {
    id:"eb2bSaleslens",
    label: "EB2B Saleslens",
    icon: "manageBasketStudioIcon",
    route: "/dashboard/eb2bSaleslens",
    navbarParentLabel: "Analytics Dashboard",
    // externalFeature: true
  },
  {
    id:"saleslens",
    label: "Saleslens",
    icon: "manageBasketStudioIcon",
    route: "/dashboard/saleslens",
    navbarParentLabel: "Analytics Dashboard",
    // externalFeature: true
  },
  {
    id: "appBuild",
    label: "App Build",
    icon: "appBuildIcon",
    route: "/dashboard/appBuild",
    navbarParentLabel: "Salescode Studio"
  },
  {
    id:"loadoutDeliveryConfirmation",
    label: "Delivery Confirmation",
    icon: "manageBasketStudioIcon",
    route: "/dashboard/manageLoadout",
    navbarParentLabel: "Settlements"
  },
  {
    id:"deliveryConfirmation",
    label: "Delivery Confirmation",
    icon: "manageBasketStudioIcon",
    route: "/dashboard/deliveryConfirmation",
    navbarParentLabel: "Settlements",
  },
  {
    id:"approvePosts",
    label: "Post Approval",
    icon: "eventConfigIcon",
    route: "/dashboard/approvePosts",
    navbarParentLabel: "Manage Posts",
  },
  {
    id:"companyPosts",
    label: "Company Post",
    icon: "eventConfigIcon",
    route: "/dashboard/companyPosts",
    navbarParentLabel: "Manage Posts",
  },
  {
    id: "scaiDashboard",
    label: "SCAI Dashboard",
    icon: "",
    route: "/dashboard/scaiDashboard",
    navbarParentLabel: "SCAI Dashboard"
  },
  {
    id:"manageForms",
    label: "Manage Forms",
    icon: "appBuildIcon",
    route: "/dashboard/manageForms",
    navbarParentLabel: "Salescode Studio"
  },
  // {
  //   id: "mdmNewFlow",
  //   label: "MDM New Flow",
  //   icon: "mdmIcon",
  //   route: "/dashboard/newFlowMDM",
  //   navbarParentLabel: "MDM and Reports"
  // },
  {
    id: "updatedFlowMDM",
    label: "Updated MDM",
    icon: "mdmIcon",
    route: "/dashboard/updatedFlowMDM",
    navbarParentLabel: "MDM and Reports"
  },
  {
    id: "collection",
    label: "Collection",
    icon: "businessImpactIcon",
    route: "/dashboard/collection",
    navbarParentLabel: "Settlements"
  },
{
    id: "customProductSequencing",
    label: "Custom Product Sequencing",
    icon: "uiConfigIcon",
    route: "/dashboard/catalogueSequencing",
    navbarParentLabel: "Salescode Studio"
  },
  {
    id:"insights",
    label: "Insights",
    icon: "manageBasketStudioIcon",
    route: "/dashboard/insights",
    navbarParentLabel: "Analytics Dashboard",
    externalFeature: true
  },
  {
    id:"outletLedger",
    label: "Outlet Ledger",
    icon: "manageBasketStudioIcon",
    route: "/dashboard/outletLedger",
    navbarParentLabel: "Accounting"
  },
  {
    id: "cloMapping",
    label:"CLO Mapping",
    icon: "uiConfigIcon",
    route: "/dashboard/cloMapping",
    navbarParentLabel: "Salescode Studio"
  },
  {
    id: "manageRequests",
    label:"Manage Requests",
    icon: "uiConfigIcon",
    route: "/dashboard/manageRequestApproval",
    navbarParentLabel: "Manage Requests"
  },
  {
    id:"salescodeStudioSettings",
    label: "Salescode Studio Settings",
    icon: "manageBasketStudioIcon",
    route: "/dashboard/settings",
    navbarParentLabel: "Settings",
  },
  {
    id:"homePage",
    label: "Home",
    icon: "manageOrder",
    route: "/dashboard/homePage",
    navbarParentLabel: "Home",
  }
];

export const allNavbarOptions : navbarOption[] = [ 'Analytics Dashboard', 'Impact Prediction', 'MDM and Reports', 'Salescode Studio', 'Manage Requests', 'Outlet Approval', 'Interface Sync Monitor', 'Performance Analytics', 'Banking', "Manage Order", "Secondary", "Primary", "Stocks", "Delivery", "Credit", "Claims", "Returns","MDM and Integration", "Settlements", "Checkmate", "Manage Posts","SCAI Dashboard",  "Primary OMS", "Accounting", "Settings", "Home" ];
